import React, { useState } from "react";

import animationData from "./loading-colour.json";

const IsLoadingHOC = (WarpedComponent) => {
  function HOC(props) {
    const [isLoading, setLoading] = useState(false);
    const [content, setContent] = useState("");
    let [color, setColor] = useState("#ffffff");

    const options = {
      animationData: animationData,
      loop: true,
      autoplay: true
    };

    const setLoadingStage = (isComponentLoading) => {
      setLoading(isComponentLoading);
    };

    return (
      <>
        {isLoading && <div className="global-loader-wrap">
          
          <div className="css-loader-wrap">
            <div className="josh-loader-web"></div>
          </div>
          <span className="loader-content">{content}</span>
        </div>}

        <WarpedComponent
          {...props}
          setLoading={setLoadingStage}
          isLoading={isLoading}
          setContent={setContent}
          content={content}
        />
      </>
    );
  }

  return HOC;
};

export default IsLoadingHOC;
